import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/produccion/reciboCaja';
import SeleccionarPeriodo from './ReciboCaja';


const ms2p = (state) => {
  return {
    ...state.recibo_caja_prd,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(SeleccionarPeriodo);
